import { Store, createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './redux/reducers';
import { StoreState } from './types/state';
import { composeWithDevTools } from 'redux-devtools-extension';
let store: Store<StoreState>;

let middleWares = [thunk];

let composeEnhancer = compose(
  composeWithDevTools(applyMiddleware(...middleWares))
);

if (process.env.NODE_ENV === 'production')
  composeEnhancer = compose(applyMiddleware(...middleWares));

store = createStore(rootReducer, undefined, composeEnhancer);
export default store;
